import PropTypes from 'prop-types';
import React from 'react';
import SlickWrapper from '../carousel/SlickWrapper';

const AboutCarousel = ({slides, isMobile}) => {
    const aboutSlider = React.createRef();
    const sliderOptions = {
        infinite: true,
        speed: 500,
        autoplay: true,
        autoplaySpeed: 4000,
        draggable: true,
        touchMove: true,
        swipeToSlide: true,
        swipe: true,
        focusOnSelect: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        accessibility: true,
        arrows: false,
        dots: false
    };

    const images = slides.map((item, index) => {
        const img = isMobile ? item.mobileImage : item.image;
        return <img key={`slide-${index}`} src={img} alt={`slide-${index}`} className="screen" />;
    });
    
    return (
        <div className="about-carousel">
            <SlickWrapper ref={aboutSlider} options={sliderOptions}>
                {images}     
            </SlickWrapper>
        </div>
    );
};
AboutCarousel.propTypes = {
    slides: PropTypes.array,
    isMobile: PropTypes.bool
}

export default AboutCarousel;
